import { render, staticRenderFns } from "./MGJHome.vue?vue&type=template&id=6840d13f&"
import script from "./MGJHome.vue?vue&type=script&lang=js&"
export * from "./MGJHome.vue?vue&type=script&lang=js&"
import style0 from "./MGJHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports